module.exports = __webpack_public_path__ + "img/c08_buildingtechdivineofferings_Normal_ua.ad7d6fc0.webp";